module.exports = __webpack_public_path__ + "static/fonderie-cea4dc4575648e6456b6f041ba4c7030.png";